/* Bellore: urun fiyatinin altina UCRETSIZ KARGO rozeti (Bellore UK'deki gibi). */
(function () {
  if (location.pathname.indexOf('/products/') === -1) return;
  function findAnchor() {
    // Ana urun fiyati (ozel yapi): .bp-price-row
    var a = document.querySelector('.bp-price-row');
    if (a && a.offsetParent) return a;
    a = document.querySelector('.bp-price-stack');
    if (a && a.offsetParent) return a;
    // Yedek: standart Horizon fiyati (urun karti / arama disinda)
    var cands = document.querySelectorAll('[ref="priceContainer"], .price');
    for (var i = 0; i < cands.length; i++) {
      var el = cands[i];
      if (el.closest('.resource-card') || el.closest('.predictive-search-results')) continue;
      if (!el.offsetParent) continue;
      return el.closest('[ref="priceContainer"]') || el;
    }
    return null;
  }
  function insert() {
    if (document.querySelector('.bp-free-ship')) return;
    var anchor = findAnchor();
    if (!anchor) return;
    var pill = document.createElement('div');
    pill.className = 'bp-free-ship';
    pill.setAttribute('style', 'display:flex;width:fit-content;align-items:center;gap:9px;margin:16px 0 4px;padding:10px 18px;border:1px solid #ecdfc4;border-radius:14px;background:#faf5ea;font-weight:800;font-size:13px;letter-spacing:.06em;color:#1a1a1a;text-transform:uppercase;line-height:1;');
    pill.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#b98a2e" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M1 4h13v11H1z"/><path d="M14 8h4l3 3v4h-7z"/><circle cx="5.5" cy="18" r="2"/><circle cx="17.5" cy="18" r="2"/></svg><span>\u00dcCRETS\u0130Z KARGO</span>';
    anchor.insertAdjacentElement('afterend', pill);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', insert); else insert();
  [200, 600, 1200, 2200].forEach(function (ms) { setTimeout(insert, ms); });
  document.addEventListener('shopify:section:load', function () { setTimeout(insert, 60); });
})();
